export default __webpack_public_path__ + "static/media/WStore_PropertyPerks.69114d98.png";